import { createContext, useContext } from "react";
import {
  ReportBespokeStore,
  ReportBespokeStoreType,
} from "./ReportBespokeStore";

export const reportBespokeStore: ReportBespokeStoreType = ReportBespokeStore();

export const ReportBespokeStoreContext = createContext(reportBespokeStore);
export const ReportBespokeStoreContextProvider =
  ReportBespokeStoreContext.Provider;

export const useReportBespoke = () => {
  return useContext(ReportBespokeStoreContext) as typeof reportBespokeStore;
};

export default reportBespokeStore;
